
// It will convert v1 careplan structure to v2 careplan structure
export const convertCareplanToV2 = plan => {
  if (!plan) return
  if (plan?.body) return plan?.body
  else return Object.values(plan)
}